import { isNullOrUndef } from '../utils/isNullOrUndef';
import { dlContactEvent } from '../events/dl.contact.event';
class ComponentFixedHelp extends HTMLElement {
    MAX_REPETITIONS = 100;
    helpBtn = this.querySelector('.fixed-help__button');
    btnLoader = this.querySelector('.fixed-help__chat-loader');
    btnText = this.querySelector('.fixed-help__button-text');
    chatState = {
        loading: false,
        loaded: false,
        opened: false
    };
    chatWrapper = null;
    constructor() {
        super();
        window.GORGIAS_CHAT_APP_ID = '6463';
        window.GORGIAS_CHAT_BASE_URL = 'us-east1-898b.production.gorgias.chat';
        window.GORGIAS_API_BASE_URL = 'config.gorgias.chat';
        document.body.addEventListener('click', (event) => {
            if (isNullOrUndef(event.target) ||
                !(event.target instanceof Element)) {
                return;
            }
            const target = event.target.closest('[data-action="run_chat"]');
            if (isNullOrUndef(target)) {
                return;
            }
            target.classList.add('chat-loading');
            event.preventDefault();
            this.openChat();
        });
        if (window.location.search.includes('chat-now')) {
            this.openChat();
        }
    }
    initChat() {
        const init = () => {
            let csic = 0;
            const chatStyling = window.setInterval(() => {
                if (++csic === this.MAX_REPETITIONS) {
                    window.clearInterval(chatStyling);
                    console.error('Gorgias init chat. Step with integration styles to the chat iframe');
                }
                const container = document.querySelector('#gorgias-chat-container');
                const chatWindow = container?.querySelector('#chat-window');
                if (isNullOrUndef(chatWindow))
                    return;
                window.GorgiasChat?.open?.();
                const chatHead = chatWindow.contentWindow?.document.querySelector('head');
                if (isNullOrUndef(chatHead) || chatHead.children.length < 1)
                    return;
                const styles = document.createElement('style');
                styles.textContent = `
            .frame-root .logo-wrapper,
            .frame-root .close-handle {
              display:none !important;
            }
            .frame-root .frame-content > div {
              height:100%; width:100%; top:0; left:0; padding:20px;
            }
            .frame-root .message-window-iframe-ofevui,
            .frame-root .message-window-iframe-sscmxe {
              padding: 0;
            }
            #conversation h3 {
              margin: 10px;
            }
            @media (max-width: 800px) {
              .frame-root .frame-content > div {
                padding:10px;
              }
            }
          `;
                chatHead.appendChild(styles);
                const chatBody = chatWindow.contentWindow?.document.querySelector('body');
                chatBody?.appendChild(styles.cloneNode(true));
                chatWindow.classList.add('fixed-help__gorgias-chat');
                chatWindow.classList.add('ae--fade');
                chatWindow.setAttribute('aria-hidden', 'true');
                this.chatWrapper = chatWindow;
                window.clearInterval(chatStyling);
                let gic = 0;
                const gorgiasInterval = window.setInterval(() => {
                    if (!isNullOrUndef(window.GorgiasChat)) {
                        window.clearInterval(gorgiasInterval);
                        this.chatState.loaded = true;
                        this.openChat();
                    }
                    else if (++gic === this.MAX_REPETITIONS) {
                        window.clearInterval(gorgiasInterval);
                        console.error('Can\'t load Gorgias events');
                    }
                });
            }, 100);
        };
        const e = new XMLHttpRequest();
        e.open('GET', 'https://config.gorgias.chat/applications/6463', true);
        e.onerror = (er) => { console.error(er); };
        e.onload = (t) => {
            if (e.readyState === 4) {
                if (e.status !== 200) {
                    console.error('Failed request GET - https://config.gorgias.chat/applications/6463');
                    return;
                }
                const n = JSON.parse(e.responseText);
                if (isNullOrUndef(n.application) || isNullOrUndef(n.bundleVersion)) {
                    throw new Error('Missing fields in the response body - https://config.gorgias.chat/applications/6463');
                }
                window.GORGIAS_CHAT_APP = n.application;
                window.GORGIAS_CHAT_BUNDLE_VERSION = n.bundleVersion;
                !isNullOrUndef(n) && n.texts && (window.GORGIAS_CHAT_TEXTS = n.texts);
                !isNullOrUndef(n) && n.sspTexts && (window.GORGIAS_CHAT_SELF_SERVICE_PORTAL_TEXTS = n.sspTexts);
                if (isNullOrUndef(document.getElementById('gorgias-chat-container'))) {
                    const r = document.createElement('script');
                    r.setAttribute('defer', '');
                    r.src = 'https://client-builds.production.gorgias.chat/{bundleVersion}/static/js/main.js'.replace('{bundleVersion}', n.bundleVersion);
                    r.addEventListener('load', init);
                    document.body.appendChild(r);
                }
            }
        };
        e.send();
        this.chatState.loading = true;
    }
    openChat() {
        this.btnLoader?.removeAttribute('hidden');
        this.btnText?.setAttribute('hidden', '');
        if (!this.chatState.loading && !this.chatState.loaded) {
            this.initChat();
        }
        if (this.chatState.loaded) {
            window.GorgiasChat?.open?.();
            this.helpBtn?.setAttribute('aria-hidden', 'true');
            this.chatWrapper?.setAttribute('aria-hidden', 'false');
            this.chatState.opened = true;
            document.querySelectorAll('.chat-loading').forEach(elem => {
                elem.classList.remove('chat-loading');
            });
            dlContactEvent('Gorgias chat');
        }
    }
}
customElements.define('fixed-help-component', ComponentFixedHelp);
